import { isEmpty } from 'lodash';

import { YardTaskCheckEntity } from '@nova/core';
import {
  isAssetValid,
  isSpotValid,
  isAreaValid,
  isCategoryValid
} from '@/modules/yard/components/YardTasksCreateTaskCheckDetails.helpers';
import { isChecklistValid } from '@/modules/yard/components/YardTasksCreateTaskCheckChecklist.helpers';

import type { CheckTaskFormData } from '@nova/core';

/**
 * Validates task data before submission
 * @param taskData - Task data to validate
 */
export function validateTask(taskData: Partial<CheckTaskFormData> | null | undefined): boolean {
  if (!taskData) {
    console.error('No task data provided');
    return false;
  }

  if (taskData.type !== 'check') {
    console.error('Invalid task type');
    return false;
  }

  if (isEmpty(taskData.subject)) {
    console.error('Subject is required');
    return false;
  }

  if (taskData.subject === YardTaskCheckEntity.Spot && !isSpotValid(taskData.spot)) {
    console.error('Spot is required for spot tasks');
    return false;
  } else if (taskData.subject === YardTaskCheckEntity.SpotArea && !isAreaValid(taskData.area)) {
    console.error('Area is required for area tasks');
    return false;
  } else if (
    taskData.subject === YardTaskCheckEntity.AssetContainer &&
    !isAssetValid(taskData.asset)
  ) {
    console.error('Asset is required for asset tasks');
    return false;
  }

  if (!isCategoryValid(taskData.category)) {
    console.error('Category is required');
    return false;
  }

  if (taskData.checklist) {
    if (!Array.isArray(taskData.checklist)) {
      console.error('Checklist must be an array');
      return false;
    } else {
      if (!isChecklistValid(taskData.checklist)) {
        console.error('Checklist item must have a description');
        return false;
      }
    }
  }

  return true;
}
